import { render, staticRenderFns } from "./user.vue?vue&type=template&id=626864ab&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=626864ab&prod&lang=less"
import style1 from "./user.vue?vue&type=style&index=1&id=626864ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626864ab",
  null
  
)

export default component.exports